import { apiSlice } from '../../../../../app/apiSlice';
import { MenuPai, MenuPaiList } from '../../../../../typesSite/menuPai/MenuPai';

import configSiteUrls from '../../../configs/configSiteUrls';

//usei o menuPai como base

const endpointUrl = configSiteUrls.SITE_MENU_PAI_EP;
const publicEndpointUrl = configSiteUrls.SITE_MENU_PUBLIC_EP;

function getMenuPais({ search }: { search: string }) {
  return {
    url: `${endpointUrl}/filter?search=${search}`,
    method: 'GET'
  };
}

function getPublicMenusSite({ escolaLegislativo }: { escolaLegislativo: boolean }) {
  return {
    url: escolaLegislativo ? `${publicEndpointUrl}/escola-legislativo` : `${publicEndpointUrl}`,
    method: 'GET'
  };
}

function addMenuPai(obj: MenuPai) {
  return {
    url: `${endpointUrl}/create`,
    method: 'POST',
    body: obj
  };
}

function deleteMenuPai({ id }: { id: string }) {
  return {
    url: `${endpointUrl}/${id}`,
    method: 'DELETE'
  };
}
function getMenuPai(id: string) {
  if (!id) {
    return {
      url: '',
      method: ''
    };
  }

  return {
    url: `${endpointUrl}/${id}`,
    method: 'GET'
  };
}
/** */

export const menuPaiApiSlice = apiSlice.injectEndpoints({
  endpoints: ({ query, mutation }) => ({
    getMenuPais: query<MenuPaiList[], { search: string }>({
      //query: (id) => `${endpointUrl}/ciencia/${id}`,
      query: getMenuPais,
      providesTags: ['MenuPai']
    }),
    getPublicMenus: query<any, { escolaLegislativo: boolean }>({
      query: getPublicMenusSite,
      providesTags: ['MenuPai']
    }),

    getMenuPai: query<MenuPai, string>({
      //query: (id) => `${endpointUrl}/ciencia/${id}`,
      query: getMenuPai,
      providesTags: ['MenuPai']
    }),
    addMenuPai: mutation<void, MenuPai>({
      query: addMenuPai,
      invalidatesTags: ['MenuPai']
    }),
    deleteMenuPai: mutation<void, { id: string }>({
      query: deleteMenuPai,
      invalidatesTags: ['MenuPai']
    })
  })
});
export const { useGetMenuPaisQuery, useGetMenuPaiQuery, useAddMenuPaiMutation, useDeleteMenuPaiMutation, useGetPublicMenusQuery } = menuPaiApiSlice;
